import { ListItem, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import PropTypes from "prop-types";

import { useState } from "react";

import MyModal from "src/components/layout/MyModal";
import { PersonSearchIcon } from "src/components/icons/SearchIcons";
import { CloseIcon } from "src/components/icons/ActionIcons";
import LazyLoader from "src/components/layout/Progress/LazyLoader";
import GlobalSearchModalContents from "./GlobalSearchModalContents";

export default function GlobalSearchListItemText() {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const onClick = () => {
    setModalIsOpen(true);
  };

  return (
    <>
      <MyModal
        isOpen={modalIsOpen}
        onClose={() => setModalIsOpen(false)}
        dialogProps={{ maxWidth: "xl" }}
        title="Haku"
        closeButtonIcon={<CloseIcon />}
        closeButtonText="SULJE">
        <LazyLoader>
          <GlobalSearchModalContents onClose={() => setModalIsOpen(false)} />
        </LazyLoader>
      </MyModal>
      <ListItem disablePadding>
        <ListItemButton onClick={onClick}>
          <ListItemIcon>
            <PersonSearchIcon />
          </ListItemIcon>
          <ListItemText primary="Haku" />
        </ListItemButton>
      </ListItem>
    </>
  );
}

GlobalSearchListItemText.propTypes = {
  fontSize: PropTypes.string,
  onClick: PropTypes.func,
};
